/**
 * Creates a single class specifier from a list of items.
 * Each item can be a string, an object or undefined.
 * If an object is passed, the object's keys are filtered by their value and used as class names.
 * Strings are used as is.
 * Falsy items (undefined, null, false etc.) are filtered out.
 *
 * @returns {string} A string with the class names merged into one.
 */
export const classNames = (
	/** @type {(string | undefined | Record<string, boolean | undefined>)[]} */
	...classes
) => {
	return classes
		.filter(Boolean)
		.map((c) => {
			if (typeof c === 'string') {
				return c
			}
			if (typeof c === 'object') {
				return Object.entries(c)
					.filter(([, value]) => value)
					.map(([key]) => key)
					.join(' ')
			}
			return ''
		})
		.join(' ')
}



// WEBPACK FOOTER //
// ./src/components/utils/classNames.js